import { t } from '@whitesharx/starfall-frontend-core';
import { pushNotification } from '@whitesharx/starfall-frontend-ui-kit';

export const emailChangeCanceledNotify = () => {
  pushNotification({
    type: 'success',
    title: t('email-change-canceled'),
  });
};

export const handleAuthError = (error: { error?: string; message?: string }) => {
  if (!error.error?.includes('popup_closed_by_user')) {
    window.Sentry?.captureException(new Error(error?.error || error.message));
    pushNotification({
      type: 'danger',
      title: t('socials-auth.failed'),
    });
  }
};
